<template>
  <section class="bg-gray-50 py-12">
    <div class="container mx-auto px-6 md:px-12 lg:px-20">
      <h2 class="text-3xl sm:text-4xl md:text-4xl max-w-screen-lg pb-8 mx-auto font-medium font-serif text-gray-800 text-center">
        How It Works
      </h2>
      <div class="space-y-12">
        <!-- Step 1 -->
        <div class="flex justify-start">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">1.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Enquire</h3>
              <p class="text-gray-600 text-md md:text-lg">
                Submit the enquiry form to share your event details and stationery needs.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 2 -->
        <div class="flex justify-end">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">2.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Consultation</h3>
              <p class="text-gray-600 text-md md:text-lg">
                We'll schedule a free, no-obligation call to discuss your vision, ideas, and wedding vibe.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 3 -->
        <div class="flex justify-start">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">3.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Moodboard & Quote</h3>
              <p class="text-gray-600 text-md md:text-lg">
              I’ll create a complimentary moodboard with design ideas, colour palettes, and fonts, along with a detailed quote.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 4 -->
        <div class="flex justify-end">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">4.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Deposit</h3>
              <p class="text-gray-600 text-md md:text-lg">
                If you’re happy with the moodboard, a 50% deposit secures your booking and starts the design process.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 5 -->
        <div class="flex justify-start">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">5.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Design & Refine</h3>
              <p class="text-gray-600 text-md md:text-lg">
                I’ll create mockups based on your preferences, and together we’ll refine the design to match your vision.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 6 -->
        <div class="flex justify-end">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">6.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Approval & Payment</h3>
              <p class="text-gray-600 text-md md:text-lg">
                Approve the final design, pay the remaining balance, and we'll begin the printing process, which typically takes 1-4 weeks depending on your needs.
              </p>
            </div>
          </div>
        </div>
        <!-- Step 7 -->
        <div class="flex justify-start">
          <div class="w-[450px] flex items-center space-x-4 text-left">
            <div class="text-4xl font-bold text-pink-700  font-serif">7.</div>
            <div>
              <h3 class="font-medium font-serif text-gray-700 text-2xl">Delivery</h3>
              <p class="text-gray-600 text-md md:text-lg">
Your custom stationery will be printed and delivered with care, ready to impress!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks",
};
</script>

<style scoped>
/* Add the dark pink color */
.text-dark-pink {
  color: #d93d64; /* Dark pink color */
}

.container {
  max-width: 1000px;
}
</style>
